export default __webpack_public_path__ + "static/media/green-blob.b0fa81b4.svg";